/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import axios from 'axios';
import type {
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

export interface Match {
  id?: string;
  platformDomainId?: string;
  entity: string;
  soid: string;
  mid?: Mid;
  createdAt: string;
  updatedAt: string;
}

export interface Mid {
  id?: string;
  generatedAt?: string;
}

export interface CConfigPart {
  id?: string;
  path?: string;
  key?: string;
  domainId?: string;
  platformId?: string;
  platformDomainId?: string;
  componentId?: string;
  position?: number;
  config?: string;
  hash?: string;
  createdAt?: string;
  updatedAt?: string;
  name?: string;
}

export interface NamespacedCCParts {
  namespace?: string;
  parts?: CConfigPart[];
  sampleConfig?: string;
}

export interface User {
  id?: string;
  /**
   * @minLength 4
   * @maxLength 12
   * @pattern ^[a-z]+[a-z0-9]*$
   */
  username?: string;
  email?: string;
  password?: string;
  enabled?: boolean;
  locked?: boolean;
  firstName?: string;
  lastName?: string;
  phone?: string;
}

export interface Domain {
  id?: string;
  slug?: string;
  permissions?: Permission[];
}

export interface Permission {
  id?: string;
  user?: User;
  role?: Role;
}

export type RoleLevel = typeof RoleLevel[keyof typeof RoleLevel];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RoleLevel = {
  ADMIN: 'ADMIN',
  TECHNICIAN: 'TECHNICIAN',
  OWNER: 'OWNER',
  DELEGATE: 'DELEGATE',
  EMPLOYEE: 'EMPLOYEE',
} as const;

export interface Role {
  id?: string;
  domain?: Domain;
  level?: RoleLevel;
  authority?: string;
}

export interface Platform {
  id?: string;
  slug?: string;
  name: string;
}

export interface PlatformDomain {
  id?: string;
  slug?: string;
  domain?: Domain;
  platform?: Platform;
}

export type HealthSummarySemaphore = typeof HealthSummarySemaphore[keyof typeof HealthSummarySemaphore];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HealthSummarySemaphore = {
  GREEN: 'GREEN',
  YELLOW: 'YELLOW',
  ORANGE: 'ORANGE',
  RED: 'RED',
} as const;

export interface HealthSummary {
  processed?: number;
  score?: number;
  semaphore?: HealthSummarySemaphore;
}

export interface LogSummary {
  expectedProcessed?: number;
  oks?: number;
  errors?: number;
  warnings?: number;
  created?: number;
  updated?: number;
  deleted?: number;
  disabled?: number;
  enabled?: number;
  createdOrUpdated?: number;
  oksWithWarnings?: number;
  fatal?: string;
}

export interface RecentHealth {
  last?: HealthSummary;
  today?: HealthSummary;
  yesterday?: HealthSummary;
}

export interface ScheduledTaskDef {
  id?: string;
  taskDef?: TaskDef;
  title?: string;
  cronExpression?: string;
  enabled?: boolean;
  namespacedCCParts?: NamespacedCCParts[];
}

export interface TaskDef {
  agentId?: string;
  id?: string;
  name?: string;
  descrip?: string;
  type?: string;
  namespacedCCParts?: NamespacedCCParts[];
  recentHealth?: RecentHealth;
  lastExec?: TaskExec;
}

export interface TaskExec {
  taskDefId?: string;
  id?: string;
  type?: string;
  slug?: string;
  name?: string;
  finished?: number;
  started?: number;
  stopped?: number;
  paused?: number;
  processTime?: number;
  lastTotalProcessTime?: number;
  progress?: number;
  logSummary?: LogSummary;
  parentId?: string;
  position?: number;
  rootId?: string;
  childrenCount?: number;
  scheduledTaskDef?: ScheduledTaskDef;
  cconfigHash?: string;
}

export interface TaskExecFileLogEntryFilter {
  from?: string;
  to?: string;
  thread?: string;
  level?: string;
  loggerName?: string;
  message?: string;
  domain?: string;
  platform?: string;
  platformDomain?: string;
  taskExecId?: string;
}

export interface TaskExecFileLogEntry {
  taskExecId?: string;
  instant?: string;
  thread?: string;
  level?: string;
  loggerName?: string;
  domain?: string;
  platform?: string;
  platformDomain?: string;
  message?: string;
}

export interface PageTaskExec {
  totalElements?: number;
  totalPages?: number;
  size?: number;
  content?: TaskExec[];
  number?: number;
  sort?: SortObject[];
  first?: boolean;
  last?: boolean;
  numberOfElements?: number;
  pageable?: PageableObject;
  empty?: boolean;
}

export interface PageableObject {
  offset?: number;
  sort?: SortObject[];
  paged?: boolean;
  pageNumber?: number;
  pageSize?: number;
  unpaged?: boolean;
}

export interface SortObject {
  direction?: string;
  nullHandling?: string;
  ascending?: boolean;
  property?: string;
  ignoreCase?: boolean;
}

export interface TaskExecLogEntryFilter {
  from?: string;
  to?: string;
  level?: string;
  loggerName?: string;
  message?: string;
  domain?: string;
  platform?: string;
  platformDomain?: string;
  taskExecId?: string;
}

export interface TaskExecLogEntry {
  taskExecId?: string;
  instant?: string;
  level?: string;
  op?: string;
  entity?: string;
  mid?: string;
  domain?: string;
  platform?: string;
  platformDomain?: string;
  exceptionType?: string;
  message?: string;
}

export interface AdapterDef {
  agentId?: string;
  platformDomain?: PlatformDomain;
  id?: string;
  name?: string;
  namespacedCCParts?: NamespacedCCParts[];
}

export interface AgentDef {
  domains?: Domain[];
  id?: string;
  name?: string;
  recentHealth?: RecentHealth;
  taskDefs?: TaskDef[];
  adapterDefs?: AdapterDef[];
}

export interface PageMatch {
  totalElements?: number;
  totalPages?: number;
  size?: number;
  content?: Match[];
  number?: number;
  sort?: SortObject[];
  first?: boolean;
  last?: boolean;
  numberOfElements?: number;
  pageable?: PageableObject;
  empty?: boolean;
}

export interface CConfigSnapshot {
  domainId?: string;
  platformId?: string;
  platformDomainId?: string;
  componentId?: string;
  hash?: string;
  config?: string;
  accessedAt?: string;
  updatedAt?: string;
  id?: CConfigSnapshotId;
}

export interface CConfigSnapshotId {
  componentId?: string;
  domainId?: string;
  platformId?: string;
  platformDomainId?: string;
  hash?: string;
}

export interface PageCConfigPart {
  totalElements?: number;
  totalPages?: number;
  size?: number;
  content?: CConfigPart[];
  number?: number;
  sort?: SortObject[];
  first?: boolean;
  last?: boolean;
  numberOfElements?: number;
  pageable?: PageableObject;
  empty?: boolean;
}

export interface PageUser {
  totalElements?: number;
  totalPages?: number;
  size?: number;
  content?: User[];
  number?: number;
  sort?: SortObject[];
  first?: boolean;
  last?: boolean;
  numberOfElements?: number;
  pageable?: PageableObject;
  empty?: boolean;
}

export interface PageRole {
  totalElements?: number;
  totalPages?: number;
  size?: number;
  content?: Role[];
  number?: number;
  sort?: SortObject[];
  first?: boolean;
  last?: boolean;
  numberOfElements?: number;
  pageable?: PageableObject;
  empty?: boolean;
}

export interface PagePlatformDomain {
  totalElements?: number;
  totalPages?: number;
  size?: number;
  content?: PlatformDomain[];
  number?: number;
  sort?: SortObject[];
  first?: boolean;
  last?: boolean;
  numberOfElements?: number;
  pageable?: PageableObject;
  empty?: boolean;
}

export interface PagePlatform {
  totalElements?: number;
  totalPages?: number;
  size?: number;
  content?: Platform[];
  number?: number;
  sort?: SortObject[];
  first?: boolean;
  last?: boolean;
  numberOfElements?: number;
  pageable?: PageableObject;
  empty?: boolean;
}

export interface PagePermission {
  totalElements?: number;
  totalPages?: number;
  size?: number;
  content?: Permission[];
  number?: number;
  sort?: SortObject[];
  first?: boolean;
  last?: boolean;
  numberOfElements?: number;
  pageable?: PageableObject;
  empty?: boolean;
}

export interface PageDomain {
  totalElements?: number;
  totalPages?: number;
  size?: number;
  content?: Domain[];
  number?: number;
  sort?: SortObject[];
  first?: boolean;
  last?: boolean;
  numberOfElements?: number;
  pageable?: PageableObject;
  empty?: boolean;
}

export interface PageTaskDef {
  totalElements?: number;
  totalPages?: number;
  size?: number;
  content?: TaskDef[];
  number?: number;
  sort?: SortObject[];
  first?: boolean;
  last?: boolean;
  numberOfElements?: number;
  pageable?: PageableObject;
  empty?: boolean;
}

export interface PageScheduledTaskDef {
  totalElements?: number;
  totalPages?: number;
  size?: number;
  content?: ScheduledTaskDef[];
  number?: number;
  sort?: SortObject[];
  first?: boolean;
  last?: boolean;
  numberOfElements?: number;
  pageable?: PageableObject;
  empty?: boolean;
}

export interface PageAgentDef {
  totalElements?: number;
  totalPages?: number;
  size?: number;
  content?: AgentDef[];
  number?: number;
  sort?: SortObject[];
  first?: boolean;
  last?: boolean;
  numberOfElements?: number;
  pageable?: PageableObject;
  empty?: boolean;
}

export interface PageAdapterDef {
  totalElements?: number;
  totalPages?: number;
  size?: number;
  content?: AdapterDef[];
  number?: number;
  sort?: SortObject[];
  first?: boolean;
  last?: boolean;
  numberOfElements?: number;
  pageable?: PageableObject;
  empty?: boolean;
}

export type FindAllMatchParams = {
platformDomainIds?: string[];
entities?: string[];
soids?: string[];
mids?: string[];
createdAtGe?: string;
createdAtLt?: string;
updatedAtGe?: string;
updatedAtLt?: string;
/**
 * Zero-based page index (0..N)
 */
page?: number;
/**
 * The size of the page to be returned
 */
size?: number;
/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
sort?: string[];
};

export type FindAllCConfigPartParams = {
/**
 * Zero-based page index (0..N)
 */
page?: number;
/**
 * The size of the page to be returned
 */
size?: number;
/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
sort?: string[];
};

export type SaveComponentConfigCConfigPartParams = {
componentId?: string;
};

export type FindAllUserParams = {
/**
 * Zero-based page index (0..N)
 */
page?: number;
/**
 * The size of the page to be returned
 */
size?: number;
/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
sort?: string[];
};

export type FindAllRoleParams = {
/**
 * Zero-based page index (0..N)
 */
page?: number;
/**
 * The size of the page to be returned
 */
size?: number;
/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
sort?: string[];
};

export type FindAllPlatformDomainParams = {
domainId?: string;
platformId?: string;
/**
 * Zero-based page index (0..N)
 */
page?: number;
/**
 * The size of the page to be returned
 */
size?: number;
/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
sort?: string[];
};

export type FindAllPlatformParams = {
/**
 * Zero-based page index (0..N)
 */
page?: number;
/**
 * The size of the page to be returned
 */
size?: number;
/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
sort?: string[];
};

export type FindAllPermissionParams = {
/**
 * Zero-based page index (0..N)
 */
page?: number;
/**
 * The size of the page to be returned
 */
size?: number;
/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
sort?: string[];
};

export type FindAllDomainParams = {
id?: string;
slug?: string;
/**
 * Zero-based page index (0..N)
 */
page?: number;
/**
 * The size of the page to be returned
 */
size?: number;
/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
sort?: string[];
};

export type FindAllTaskExecParams = {
taskDefId?: string;
parentId?: string;
onlyRoots?: boolean;
finished?: boolean;
scheduledTaskDefId?: string;
/**
 * Zero-based page index (0..N)
 */
page?: number;
/**
 * The size of the page to be returned
 */
size?: number;
/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
sort?: string[];
};

export type GetTaskDefExecutionsTaskExecParams = {
/**
 * Zero-based page index (0..N)
 */
page?: number;
/**
 * The size of the page to be returned
 */
size?: number;
/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
sort?: string[];
};

export type GetScheduledTaskDefExecutionsTaskExecParams = {
/**
 * Zero-based page index (0..N)
 */
page?: number;
/**
 * The size of the page to be returned
 */
size?: number;
/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
sort?: string[];
};

export type FindAllTaskDefParams = {
/**
 * Zero-based page index (0..N)
 */
page?: number;
/**
 * The size of the page to be returned
 */
size?: number;
/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
sort?: string[];
};

export type FindAllScheduledTaskDefParams = {
/**
 * Zero-based page index (0..N)
 */
page?: number;
/**
 * The size of the page to be returned
 */
size?: number;
/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
sort?: string[];
};

export type FindAllAgentDefParams = {
/**
 * Zero-based page index (0..N)
 */
page?: number;
/**
 * The size of the page to be returned
 */
size?: number;
/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
sort?: string[];
};

export type FindAllAdapterDefParams = {
/**
 * Zero-based page index (0..N)
 */
page?: number;
/**
 * The size of the page to be returned
 */
size?: number;
/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
sort?: string[];
};

export type HomeShopifyControllerParams = {
shop: string;
};

export type PreferencesShopifyControllerParams = {
shop: string;
};

export type AuthCallbackShopifyControllerParams = {
shop: string;
code: string;
state: string;
};

export type GetComponentConfigCConfigPartParams = {
componentId?: string;
};

export type FindUserByUsernameOrEmailParams = {
search?: string;
/**
 * Zero-based page index (0..N)
 */
page?: number;
/**
 * The size of the page to be returned
 */
size?: number;
/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
sort?: string[];
};

export type FindUserByTextParams = {
search?: string;
/**
 * Zero-based page index (0..N)
 */
page?: number;
/**
 * The size of the page to be returned
 */
size?: number;
/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
sort?: string[];
};

export type FindUserByDomainParams = {
domainId: string;
/**
 * Zero-based page index (0..N)
 */
page?: number;
/**
 * The size of the page to be returned
 */
size?: number;
/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
sort?: string[];
};

export type GetDomainAssignableRoleLevelsRoleParams = {
domainId: string;
};

export type GetDomainAssignableRoleLevelsRole200Item = typeof GetDomainAssignableRoleLevelsRole200Item[keyof typeof GetDomainAssignableRoleLevelsRole200Item];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetDomainAssignableRoleLevelsRole200Item = {
  ADMIN: 'ADMIN',
  TECHNICIAN: 'TECHNICIAN',
  OWNER: 'OWNER',
  DELEGATE: 'DELEGATE',
  EMPLOYEE: 'EMPLOYEE',
} as const;

export type FindPlatformDomainByDomainParams = {
/**
 * Zero-based page index (0..N)
 */
page?: number;
/**
 * The size of the page to be returned
 */
size?: number;
/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
sort?: string[];
};

export type FindPlatformByTextParams = {
search?: string;
/**
 * Zero-based page index (0..N)
 */
page?: number;
/**
 * The size of the page to be returned
 */
size?: number;
/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
sort?: string[];
};

export type FindPermissionByUserParams = {
/**
 * Zero-based page index (0..N)
 */
page?: number;
/**
 * The size of the page to be returned
 */
size?: number;
/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
sort?: string[];
};

export type FindPermissionByDomainParams = {
/**
 * Zero-based page index (0..N)
 */
page?: number;
/**
 * The size of the page to be returned
 */
size?: number;
/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
sort?: string[];
};

export type FindDomainByTextParams = {
search?: string;
/**
 * Zero-based page index (0..N)
 */
page?: number;
/**
 * The size of the page to be returned
 */
size?: number;
/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
sort?: string[];
};

export type FindTaskDefByAgentParams = {
agentId: string;
/**
 * Zero-based page index (0..N)
 */
page?: number;
/**
 * The size of the page to be returned
 */
size?: number;
/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
sort?: string[];
};

export type FindScheduledTaskDefByAgentParams = {
agentId: string;
/**
 * Zero-based page index (0..N)
 */
page?: number;
/**
 * The size of the page to be returned
 */
size?: number;
/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
sort?: string[];
};

export type FindAgentDefByTextParams = {
search?: string;
/**
 * Zero-based page index (0..N)
 */
page?: number;
/**
 * The size of the page to be returned
 */
size?: number;
/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
sort?: string[];
};

export type FindAdapterDefByAgentParams = {
agentId: string;
/**
 * Zero-based page index (0..N)
 */
page?: number;
/**
 * The size of the page to be returned
 */
size?: number;
/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
sort?: string[];
};

export const findAllMatch = <TData = AxiosResponse<PageMatch>>(
    params?: FindAllMatchParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/matcher/match`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const saveMatch = <TData = AxiosResponse<Match>>(
    match: Match, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/matcher/match`,
      match,options
    );
  }

export const findAllCConfigPart = <TData = AxiosResponse<PageCConfigPart>>(
    params?: FindAllCConfigPartParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/cconfig/part`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const saveCConfigPart = <TData = AxiosResponse<CConfigPart>>(
    cConfigPart: CConfigPart, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/cconfig/part`,
      cConfigPart,options
    );
  }

export const saveComponentConfigCConfigPart = <TData = AxiosResponse<NamespacedCCParts[]>>(
    domain: string,
    platform: string,
    platformDomain: string,
    namespacedCCParts: NamespacedCCParts[],
    params?: SaveComponentConfigCConfigPartParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/cconfig/part/${domain}/${platform}/${platformDomain}`,
      namespacedCCParts,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const findAllUser = <TData = AxiosResponse<PageUser>>(
    params?: FindAllUserParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/auth/user`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const saveUser = <TData = AxiosResponse<User>>(
    user: User, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/auth/user`,
      user,options
    );
  }

export const findAllRole = <TData = AxiosResponse<PageRole>>(
    params?: FindAllRoleParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/auth/role`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const saveRole = <TData = AxiosResponse<Role>>(
    role: Role, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/auth/role`,
      role,options
    );
  }

export const findAllPlatformDomain = <TData = AxiosResponse<PagePlatformDomain>>(
    params?: FindAllPlatformDomainParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/auth/platformdomain`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const savePlatformDomain = <TData = AxiosResponse<PlatformDomain>>(
    platformDomain: PlatformDomain, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/auth/platformdomain`,
      platformDomain,options
    );
  }

export const findAllPlatform = <TData = AxiosResponse<PagePlatform>>(
    params?: FindAllPlatformParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/auth/platform`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const savePlatform = <TData = AxiosResponse<Platform>>(
    platform: Platform, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/auth/platform`,
      platform,options
    );
  }

export const findAllPermission = <TData = AxiosResponse<PagePermission>>(
    params?: FindAllPermissionParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/auth/permission`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const savePermission = <TData = AxiosResponse<Permission>>(
    permission: Permission, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/auth/permission`,
      permission,options
    );
  }

export const findAllDomain = <TData = AxiosResponse<PageDomain>>(
    params?: FindAllDomainParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/auth/domain`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const saveDomain = <TData = AxiosResponse<Domain>>(
    domain: Domain, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/auth/domain`,
      domain,options
    );
  }

export const findAllTaskExec = <TData = AxiosResponse<PageTaskExec>>(
    params?: FindAllTaskExecParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/agent/taskExec`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const saveTaskExec = <TData = AxiosResponse<TaskExec>>(
    taskExec: TaskExec, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/agent/taskExec`,
      taskExec,options
    );
  }

export const getChildrenTaskExec = <TData = AxiosResponse<TaskExec[]>>(
    taskExecId: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/agent/taskExec/${taskExecId}/children`,undefined,options
    );
  }

export const stopTaskExec = <TData = AxiosResponse<void>>(
    taskExecId: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/agent/taskExec/stop/${taskExecId}`,undefined,options
    );
  }

export const startTaskExec = <TData = AxiosResponse<string>>(
    taskDefId: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/agent/taskExec/start/taskDef/${taskDefId}`,undefined,options
    );
  }

export const startScheduledTaskExec = <TData = AxiosResponse<string>>(
    scheduledTaskDefId: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/agent/taskExec/start/scheduledTaskDef/${scheduledTaskDefId}`,undefined,options
    );
  }

export const resumeTaskExec = <TData = AxiosResponse<boolean>>(
    taskExecId: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/agent/taskExec/resume/${taskExecId}`,undefined,options
    );
  }

export const pauseTaskExec = <TData = AxiosResponse<boolean>>(
    taskExecId: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/agent/taskExec/pause/${taskExecId}`,undefined,options
    );
  }

export const getFileLogEntriesTaskExec = <TData = AxiosResponse<TaskExecFileLogEntry[]>>(
    taskExecFileLogEntryFilter: TaskExecFileLogEntryFilter, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/agent/taskExec/fileLog`,
      taskExecFileLogEntryFilter,options
    );
  }

export const getTaskDefExecutionsTaskExec = <TData = AxiosResponse<PageTaskExec>>(
    taskDefId: string,
    params?: GetTaskDefExecutionsTaskExecParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/agent/taskExec/byTaskDef/${taskDefId}`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getScheduledTaskDefExecutionsTaskExec = <TData = AxiosResponse<PageTaskExec>>(
    scheduledTaskDefId: string,
    params?: GetScheduledTaskDefExecutionsTaskExecParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/agent/taskExec/byScheduledTaskDef/${scheduledTaskDefId}`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getLogEntriesTaskExec = <TData = AxiosResponse<TaskExecLogEntry[]>>(
    taskExecLogEntryFilter: TaskExecLogEntryFilter, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/agent/taskExec/adapterLog`,
      taskExecLogEntryFilter,options
    );
  }

export const findAllTaskDef = <TData = AxiosResponse<PageTaskDef>>(
    params?: FindAllTaskDefParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/agent/taskDef`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const saveTaskDef = <TData = AxiosResponse<TaskDef>>(
    taskDef: TaskDef, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/agent/taskDef`,
      taskDef,options
    );
  }

export const findAllScheduledTaskDef = <TData = AxiosResponse<PageScheduledTaskDef>>(
    params?: FindAllScheduledTaskDefParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/agent/scheduledTaskDef`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const saveScheduledTaskDef = <TData = AxiosResponse<ScheduledTaskDef>>(
    scheduledTaskDef: ScheduledTaskDef, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/agent/scheduledTaskDef`,
      scheduledTaskDef,options
    );
  }

export const findAllAgentDef = <TData = AxiosResponse<PageAgentDef>>(
    params?: FindAllAgentDefParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/agent/agentDef`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const saveAgentDef = <TData = AxiosResponse<AgentDef>>(
    agentDef: AgentDef, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/agent/agentDef`,
      agentDef,options
    );
  }

export const findAllAdapterDef = <TData = AxiosResponse<PageAdapterDef>>(
    params?: FindAllAdapterDefParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/agent/adapterDef`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const saveAdapterDef = <TData = AxiosResponse<AdapterDef>>(
    adapterDef: AdapterDef, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/agent/adapterDef`,
      adapterDef,options
    );
  }

export const getMatch = <TData = AxiosResponse<Match>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/matcher/match/${id}`,options
    );
  }

export const deleteMatch = <TData = AxiosResponse<void>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.delete(
      `/matcher/match/${id}`,options
    );
  }

export const homeShopifyController = <TData = AxiosResponse<void>>(
    params: HomeShopifyControllerParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/extension/shopify`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const preferencesShopifyController = <TData = AxiosResponse<string>>(
    params: PreferencesShopifyControllerParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/extension/shopify/preferences`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const authCallbackShopifyController = <TData = AxiosResponse<void>>(
    params: AuthCallbackShopifyControllerParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/extension/shopify/api/auth`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getByNamespacesCConfigSnapshot = <TData = AxiosResponse<CConfigSnapshot>>(
    domain: string,
    platform: string,
    platformDomain: string,
    componentId: string,
    namespaces: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/cconfig/${domain}/${platform}/${platformDomain}/${componentId}/${namespaces}`,options
    );
  }

export const getByHashCConfigSnapshot = <TData = AxiosResponse<CConfigSnapshot>>(
    domain: string,
    platform: string,
    platformDomain: string,
    componentId: string,
    hash: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/cconfig/${domain}/${platform}/${platformDomain}/${componentId}/${hash}`,options
    );
  }

export const getCConfigPart = <TData = AxiosResponse<CConfigPart>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/cconfig/part/${id}`,options
    );
  }

export const deleteCConfigPart = <TData = AxiosResponse<void>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.delete(
      `/cconfig/part/${id}`,options
    );
  }

export const getComponentConfigCConfigPart = <TData = AxiosResponse<NamespacedCCParts[]>>(
    domain: string,
    platform: string,
    platformDomain: string,
    namespaces: string,
    params?: GetComponentConfigCConfigPartParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/cconfig/part/${domain}/${platform}/${platformDomain}/${namespaces}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getUser = <TData = AxiosResponse<User>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/auth/user/${id}`,options
    );
  }

export const deleteUser = <TData = AxiosResponse<void>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.delete(
      `/auth/user/${id}`,options
    );
  }

export const findUserByUsernameOrEmail = <TData = AxiosResponse<PageUser>>(
    params?: FindUserByUsernameOrEmailParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/auth/user/findByUsernameOrEmail`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const findUserByText = <TData = AxiosResponse<PageUser>>(
    params?: FindUserByTextParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/auth/user/findByText`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const findUserByDomain = <TData = AxiosResponse<PageUser>>(
    params: FindUserByDomainParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/auth/user/findByDomain`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getRole = <TData = AxiosResponse<Role>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/auth/role/${id}`,options
    );
  }

export const deleteRole = <TData = AxiosResponse<void>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.delete(
      `/auth/role/${id}`,options
    );
  }

export const getDomainAssignableRoleLevelsRole = <TData = AxiosResponse<GetDomainAssignableRoleLevelsRole200Item[]>>(
    params: GetDomainAssignableRoleLevelsRoleParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/auth/role/getDomainAssignableRoleLevels`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getPlatformDomain = <TData = AxiosResponse<PlatformDomain>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/auth/platformdomain/${id}`,options
    );
  }

export const deletePlatformDomain = <TData = AxiosResponse<void>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.delete(
      `/auth/platformdomain/${id}`,options
    );
  }

export const findPlatformDomainByDomain = <TData = AxiosResponse<PagePlatformDomain>>(
    domainId: string,
    params?: FindPlatformDomainByDomainParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/auth/platformdomain/findByDomain/${domainId}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getPlatform = <TData = AxiosResponse<Platform>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/auth/platform/${id}`,options
    );
  }

export const deletePlatform = <TData = AxiosResponse<void>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.delete(
      `/auth/platform/${id}`,options
    );
  }

export const findPlatformByText = <TData = AxiosResponse<PagePlatform>>(
    params?: FindPlatformByTextParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/auth/platform/findByText`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getPermission = <TData = AxiosResponse<Permission>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/auth/permission/${id}`,options
    );
  }

export const deletePermission = <TData = AxiosResponse<void>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.delete(
      `/auth/permission/${id}`,options
    );
  }

export const findPermissionByUser = <TData = AxiosResponse<PagePermission>>(
    userId: string,
    params?: FindPermissionByUserParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/auth/permission/findByUser/${userId}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const findPermissionByDomain = <TData = AxiosResponse<PagePermission>>(
    domainId: string,
    params?: FindPermissionByDomainParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/auth/permission/findByDomain/${domainId}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getDomain = <TData = AxiosResponse<Domain>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/auth/domain/${id}`,options
    );
  }

export const deleteDomain = <TData = AxiosResponse<void>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.delete(
      `/auth/domain/${id}`,options
    );
  }

export const findDomainByText = <TData = AxiosResponse<PageDomain>>(
    params?: FindDomainByTextParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/auth/domain/findByText`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getTaskExec = <TData = AxiosResponse<TaskExec>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/agent/taskExec/${id}`,options
    );
  }

export const deleteTaskExec = <TData = AxiosResponse<void>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.delete(
      `/agent/taskExec/${id}`,options
    );
  }

export const getTaskDef = <TData = AxiosResponse<TaskDef>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/agent/taskDef/${id}`,options
    );
  }

export const deleteTaskDef = <TData = AxiosResponse<void>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.delete(
      `/agent/taskDef/${id}`,options
    );
  }

export const findTaskDefByAgent = <TData = AxiosResponse<PageTaskDef>>(
    params: FindTaskDefByAgentParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/agent/taskDef/findByAgent`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getScheduledTaskDef = <TData = AxiosResponse<ScheduledTaskDef>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/agent/scheduledTaskDef/${id}`,options
    );
  }

export const deleteScheduledTaskDef = <TData = AxiosResponse<void>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.delete(
      `/agent/scheduledTaskDef/${id}`,options
    );
  }

export const findScheduledTaskDefByAgent = <TData = AxiosResponse<PageScheduledTaskDef>>(
    params: FindScheduledTaskDefByAgentParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/agent/scheduledTaskDef/findByAgent`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getAgentDef = <TData = AxiosResponse<AgentDef>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/agent/agentDef/${id}`,options
    );
  }

export const deleteAgentDef = <TData = AxiosResponse<void>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.delete(
      `/agent/agentDef/${id}`,options
    );
  }

export const getDomainsAgentDef = <TData = AxiosResponse<Domain[]>>(
    agentDefId: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/agent/agentDef/${agentDefId}/domains`,options
    );
  }

export const findAgentDefByText = <TData = AxiosResponse<PageAgentDef>>(
    params?: FindAgentDefByTextParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/agent/agentDef/findByText`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getAdapterDef = <TData = AxiosResponse<AdapterDef>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/agent/adapterDef/${id}`,options
    );
  }

export const deleteAdapterDef = <TData = AxiosResponse<void>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.delete(
      `/agent/adapterDef/${id}`,options
    );
  }

export const findAdapterDefByAgent = <TData = AxiosResponse<PageAdapterDef>>(
    params: FindAdapterDefByAgentParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/agent/adapterDef/findByAgent`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export type FindAllMatchResult = AxiosResponse<PageMatch>
export type SaveMatchResult = AxiosResponse<Match>
export type FindAllCConfigPartResult = AxiosResponse<PageCConfigPart>
export type SaveCConfigPartResult = AxiosResponse<CConfigPart>
export type SaveComponentConfigCConfigPartResult = AxiosResponse<NamespacedCCParts[]>
export type FindAllUserResult = AxiosResponse<PageUser>
export type SaveUserResult = AxiosResponse<User>
export type FindAllRoleResult = AxiosResponse<PageRole>
export type SaveRoleResult = AxiosResponse<Role>
export type FindAllPlatformDomainResult = AxiosResponse<PagePlatformDomain>
export type SavePlatformDomainResult = AxiosResponse<PlatformDomain>
export type FindAllPlatformResult = AxiosResponse<PagePlatform>
export type SavePlatformResult = AxiosResponse<Platform>
export type FindAllPermissionResult = AxiosResponse<PagePermission>
export type SavePermissionResult = AxiosResponse<Permission>
export type FindAllDomainResult = AxiosResponse<PageDomain>
export type SaveDomainResult = AxiosResponse<Domain>
export type FindAllTaskExecResult = AxiosResponse<PageTaskExec>
export type SaveTaskExecResult = AxiosResponse<TaskExec>
export type GetChildrenTaskExecResult = AxiosResponse<TaskExec[]>
export type StopTaskExecResult = AxiosResponse<void>
export type StartTaskExecResult = AxiosResponse<string>
export type StartScheduledTaskExecResult = AxiosResponse<string>
export type ResumeTaskExecResult = AxiosResponse<boolean>
export type PauseTaskExecResult = AxiosResponse<boolean>
export type GetFileLogEntriesTaskExecResult = AxiosResponse<TaskExecFileLogEntry[]>
export type GetTaskDefExecutionsTaskExecResult = AxiosResponse<PageTaskExec>
export type GetScheduledTaskDefExecutionsTaskExecResult = AxiosResponse<PageTaskExec>
export type GetLogEntriesTaskExecResult = AxiosResponse<TaskExecLogEntry[]>
export type FindAllTaskDefResult = AxiosResponse<PageTaskDef>
export type SaveTaskDefResult = AxiosResponse<TaskDef>
export type FindAllScheduledTaskDefResult = AxiosResponse<PageScheduledTaskDef>
export type SaveScheduledTaskDefResult = AxiosResponse<ScheduledTaskDef>
export type FindAllAgentDefResult = AxiosResponse<PageAgentDef>
export type SaveAgentDefResult = AxiosResponse<AgentDef>
export type FindAllAdapterDefResult = AxiosResponse<PageAdapterDef>
export type SaveAdapterDefResult = AxiosResponse<AdapterDef>
export type GetMatchResult = AxiosResponse<Match>
export type DeleteMatchResult = AxiosResponse<void>
export type HomeShopifyControllerResult = AxiosResponse<void>
export type PreferencesShopifyControllerResult = AxiosResponse<string>
export type AuthCallbackShopifyControllerResult = AxiosResponse<void>
export type GetByNamespacesCConfigSnapshotResult = AxiosResponse<CConfigSnapshot>
export type GetByHashCConfigSnapshotResult = AxiosResponse<CConfigSnapshot>
export type GetCConfigPartResult = AxiosResponse<CConfigPart>
export type DeleteCConfigPartResult = AxiosResponse<void>
export type GetComponentConfigCConfigPartResult = AxiosResponse<NamespacedCCParts[]>
export type GetUserResult = AxiosResponse<User>
export type DeleteUserResult = AxiosResponse<void>
export type FindUserByUsernameOrEmailResult = AxiosResponse<PageUser>
export type FindUserByTextResult = AxiosResponse<PageUser>
export type FindUserByDomainResult = AxiosResponse<PageUser>
export type GetRoleResult = AxiosResponse<Role>
export type DeleteRoleResult = AxiosResponse<void>
export type GetDomainAssignableRoleLevelsRoleResult = AxiosResponse<GetDomainAssignableRoleLevelsRole200Item[]>
export type GetPlatformDomainResult = AxiosResponse<PlatformDomain>
export type DeletePlatformDomainResult = AxiosResponse<void>
export type FindPlatformDomainByDomainResult = AxiosResponse<PagePlatformDomain>
export type GetPlatformResult = AxiosResponse<Platform>
export type DeletePlatformResult = AxiosResponse<void>
export type FindPlatformByTextResult = AxiosResponse<PagePlatform>
export type GetPermissionResult = AxiosResponse<Permission>
export type DeletePermissionResult = AxiosResponse<void>
export type FindPermissionByUserResult = AxiosResponse<PagePermission>
export type FindPermissionByDomainResult = AxiosResponse<PagePermission>
export type GetDomainResult = AxiosResponse<Domain>
export type DeleteDomainResult = AxiosResponse<void>
export type FindDomainByTextResult = AxiosResponse<PageDomain>
export type GetTaskExecResult = AxiosResponse<TaskExec>
export type DeleteTaskExecResult = AxiosResponse<void>
export type GetTaskDefResult = AxiosResponse<TaskDef>
export type DeleteTaskDefResult = AxiosResponse<void>
export type FindTaskDefByAgentResult = AxiosResponse<PageTaskDef>
export type GetScheduledTaskDefResult = AxiosResponse<ScheduledTaskDef>
export type DeleteScheduledTaskDefResult = AxiosResponse<void>
export type FindScheduledTaskDefByAgentResult = AxiosResponse<PageScheduledTaskDef>
export type GetAgentDefResult = AxiosResponse<AgentDef>
export type DeleteAgentDefResult = AxiosResponse<void>
export type GetDomainsAgentDefResult = AxiosResponse<Domain[]>
export type FindAgentDefByTextResult = AxiosResponse<PageAgentDef>
export type GetAdapterDefResult = AxiosResponse<AdapterDef>
export type DeleteAdapterDefResult = AxiosResponse<void>
export type FindAdapterDefByAgentResult = AxiosResponse<PageAdapterDef>
